<template>
  <div>
    {{ws}}

    <md-content>

      <md-field :class="messageClass">
        <label>Имя пользователя</label>
        <md-input v-model="userName" required/>
        <span class="md-error"> Укажите имя пользвателя </span>
      </md-field>

      <md-field :class="messageClass">
        <label>Пароль</label>
        <md-input v-model="password" type="password" required/>
        <span class="md-error"> Укажите пароль </span>
      </md-field>

      <md-button class="md-raised md-primary" @click="login" v-if="!inLogin">Войти</md-button>
      <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate" v-if="inLogin"/>

    </md-content>
  </div>
</template>

<script>
  import urls from '../const'

  export default {
    data() {
      return {
        userName: '',
        password: '',
        hasMessages: false,
        inLogin: false,
      }
    },
    methods: {
      login: function (event) {
        let app = this;
        app.inLogin = true;

        if (this.userName === '' || this.password === '') {
          app.hasMessages = true;
          app.inLogin = false;
          return;
        }
        this.hasMessages = false;

        this.$api.post(urls.loginURL, {
          username: this.userName,
          password: this.password,
        })
          .then(function (response) {
            if (response.data.success) {
              app.$store.commit({
                type: 'reconnectWS',
              });
              app.inLogin = false;
            } else {
              app.hasMessages = true;
              app.inLogin = false;
            }
            console.log(response)
          })
          .catch(function (error) {
            app.inLogin = false;
            console.log(error);
          });
      }
    },
    computed: {
      messageClass() {
        return {
          'md-invalid': this.hasMessages
        }
      },
      ws() {
        if (this.$store.getters.getWSConnectState.connect) {
          // перейти на одну запись назад, эквивалентно history.back()
          // что бы юзер обратно шол не сам
          this.$router.push("/");
        }
        return '';
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Login.vue